import React, { useState, useEffect } from 'react';
import Turnstile from 'react-turnstile';
import usePersonalData from '../../../hooks/usePersonalData';
import useDealershipsData from '../../../hooks/useDealershipsData';
import useLinksData from '../../../hooks/useLinksData';
import useLeadData from '../../../hooks/useLeadData';
import useConfiguratorData from '../../../hooks/useConfiguratorData';
import DealershipCustomDropDown from '../../../../utils/DealershipCustomDropDown';
import { isRutValid } from '../../../../utils';
import MaskedInput from 'react-text-mask';
import RutTextMask from 'rut-text-mask';
import Axios from 'axios';

const ModalOutOfStockModelBody = ({ onCloseModal, selectedModel }) => {
    const { getPersonalData, setPersonalData } = usePersonalData();
    const { dealerships, getDealerships, selectedDealership, setSelectedDealership } = useDealershipsData();
    const { getLinks } = useLinksData();
    const { getPreselectedDealerId } = useConfiguratorData();

    const [ regions, setRegions ] = useState([]);
    const [ brands, setBrands ] = useState([]);
    const [ selectedRegion, setSelectedRegion ] = useState({});
    const [ selectedBrand, setSelectedBrand ] = useState({});
    const [ selectedVersion, setSelectedVersion ] = useState({});
    const [ checkboxValue, setCheckboxValue ] = useState(false);
    const [ invalidEmail, setInvalidEmail ] = useState(false);
    const [ invalidPhoneNumber, setInvalidPhoneNumber ] = useState(false);
    const [ finalModalIsOpen, setFinalModalIsOpen ] = useState(false);
    const [ preselectedRegionValidated, setPreselectedRegionValidated ] = useState(false);
    const [ preselectedBrandValidated, setPreselectedBrandValidated ] = useState(false);
    const [ turnstileToken, setTurnstileToken ] = useState(false);

    const preselectedDealerId = getPreselectedDealerId();
    const personalData = getPersonalData();
    const links = getLinks();
    const rexEmail = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const rexPhoneNumber = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,6}$/;
    const formValid = personalData.full_name && personalData.email && personalData.phone_number && isRutValid(personalData.rut) && checkboxValue && !invalidEmail && !invalidPhoneNumber && selectedVersion?.id && turnstileToken;

    const { createOutOfStockLead } = useLeadData();

    const sitekey = document.getElementById("recaptcha_sitekey").getAttribute('value');

    useEffect(() => {
        getDealerships();
        Axios.get(`/api/dealerships/regions`)
        .then(response => {
            setRegions(response.data);
        })
        .catch((error) => {
            console.error(error);
        });
    }, []);


    useEffect(() => {
        /**
         * se filtra los dealers por region seleccionada
         * se filtra los dealers restantes por los que tengan asignada brand
         * se mapea el array para extraer las brands
         * ser ordenan las brands por nombre
         * Map usa la varita 🧙‍♂️ cuando le pasamos el id como key y el ojeto completo como value
         * y como no permite keys repetidos al llamar a values() solo tenemos las brands ordenadas sin repetir
         * ✨ M A G I A ✨
         */

        const filteredSortedBrands = dealerships.filter(dealer => dealer.region_id === selectedRegion.id)
        .filter(dealer => dealer.brand_id !== null)
        .map(dealer => ({id: dealer.brand_id, name: dealer.brand_name, rating: dealer.rating}));
        setBrands([...new Map(filteredSortedBrands.map(brand => [brand['id'], brand])).values()].sort((a, b) => (a.rating < b.rating) ? 1 : -1));
    }, [selectedRegion]);

    useEffect(() => {
        if(preselectedDealerId && dealerships.some(item => item.brand_id === preselectedDealerId)){
            let dealership = dealerships.find(item => item.brand_id === preselectedDealerId);
            let region = regions.find(region => region.id === dealership.region_id);
            setSelectedRegion(region ? region : {});
            setPreselectedRegionValidated(true)
        }
    }, [dealerships, regions, brands])

    useEffect(() => {
        if(preselectedDealerId && dealerships.some(item => item.brand_id === preselectedDealerId)){
            let dealership = dealerships.find(item => item.brand_id === preselectedDealerId);
            let brand = brands.find(brand => brand.id === dealership.brand_id);
            setSelectedBrand(brand ? brand : {});
            setPreselectedBrandValidated(true)
        }
    },[brands])

    const handlePersonalDataInputChange = (e) => {
        if(e.target.name === 'email') validateEmail(e.target.value);
        if(e.target.name === 'phone_number') validatePhoneNumber(e.target.value);
        setPersonalData({[e.target.name]: e.target.value});
    }
    
    const handleRegionInputChange = (e) => {
        setSelectedRegion(e);
        setSelectedBrand({})
        setSelectedDealership({});
    }

    const handleVersionInputChange = (e) => {
        setSelectedVersion(e);
    }

    const handleBrandInputChange = (e) => {
        setSelectedBrand(e);
        setSelectedDealership({})
    }

    const handleDealershipInputChange = (e) => {
        setSelectedDealership(e);
    }


    const handleCheckboxChange = (e) => {
        setCheckboxValue(e.target.checked);
    }

    const validateEmail = (email) => {
        setInvalidEmail(!rexEmail.test(email));
    }

    const validatePhoneNumber = (phoneNumber) => {
        setInvalidPhoneNumber(!rexPhoneNumber.test(phoneNumber));
    }

    const finishLeadRegister = () => {
        createOutOfStockLead(selectedVersion);
        setFinalModalIsOpen(true);
    }

    const dealershipFilter = () => {
        if(preselectedBrandValidated){
            return dealerships.filter(item => item.brand_id === selectedBrand.id)
        }
        return dealerships.filter(item => item.region_id === selectedRegion.id && item.brand_id === selectedBrand.id)
    }

    const handleTokenSubmit = (token) => {
        fetch("/recaptcha/", {
            method: "POST",
            body: JSON.stringify({ token: token }),
            headers: {
                "Content-Type": "application/json",
                'X-CSRFToken': document.querySelector('meta[name ="csrf-token"]').content
            },
        })
        .then(response => response.json())
        .then((data) => {
            if (data.success){
                setTurnstileToken(true);
            }
        })
        .catch((error) => {
            console.log("ERROR", error);
        });
    }

    return (
        <>
            {!finalModalIsOpen ? 
                <div className="modal-box">
                    <div className="close-button icon close" id="close-modal" onClick={onCloseModal}></div>
                    <div className="modal-body">
                        <section className="model-info">
                            <div className="title">
                                <h2>¡Te avisaremos cuando esté disponible este modelo!</h2>
                            </div>
                            <p className="instruction">
                                <strong>Por ahora este modelo no está disponible para realizar una cotización, déjanos tus datos y te contactaremos una vez que tengamos disponibilidad.</strong>
                            </p>
                        </section>
                        <section>
                            <section className="dropdowns-container">
                                <DealershipCustomDropDown 
                                    selectedOption={selectedVersion} 
                                    label="¿Qué versión te interesa?" 
                                    items={selectedModel.versions} 
                                    onClickOption={(e) => handleVersionInputChange(e)}/> 
                            </section>
                            <form id="personal-data-form" className="contact-form">
                                <div className="form-element">
                                    <input 
                                        className="input" 
                                        type="text" 
                                        placeholder="¿Cómo te llamas?" 
                                        value={personalData.full_name} 
                                        name="full_name" 
                                        onChange={(e) => handlePersonalDataInputChange(e)}>
                                    </input>
                                </div>
                                <div className="form-element">
                                    <input  
                                        className={"input" + (invalidEmail ? " error" : "")} 
                                        type="text" 
                                        placeholder="Ingresa tu email" 
                                        value={personalData.email} 
                                        name="email" 
                                        onChange={(e) => handlePersonalDataInputChange(e)} required>
                                    </input>
                                </div>
                                <div className="two-columns">
                                    <div className="form-element">
                                        <MaskedInput
                                            mask={RutTextMask}
                                            name="rut"
                                            placeholder="RUT"
                                            value={personalData.rut}
                                            data-skip-imask="true"
                                            guide={false}
                                            keepCharPositions={false}
                                            autoComplete="off"
                                            className={personalData.rut.length >= 8 && !isRutValid(personalData.rut) ? 'error' : null}
                                            onChange={(e) => handlePersonalDataInputChange(e)} />
                                    </div>
                                    <div className="form-element">
                                        <input 
                                            className={"input" + (invalidPhoneNumber ? " error" : "")} 
                                            type="text" 
                                            placeholder="Teléfono" 
                                            value={personalData.phone_number} 
                                            name="phone_number" 
                                            onChange={(e) => handlePersonalDataInputChange(e)}>
                                        </input>
                                    </div>
                                </div>
                                <Turnstile
                                    theme="light"
                                    sitekey={sitekey}
                                    onVerify={(token) => {
                                        handleTokenSubmit(token);
                                    }}
                                />
                            </form>
                            <section className="model-info">
                                <p className="instruction">Para mejorar tu experiencia y brindarte un mejor servicio, necesitamos que elijas un concesionario</p>
                            </section>
                            <section className="dropdowns-container">
                                <DealershipCustomDropDown 
                                    selectedOption={preselectedBrandValidated ? {} : selectedRegion} 
                                    label="Región" 
                                    items={regions} 
                                    isDisabled={preselectedRegionValidated}
                                    onClickOption={(e) => handleRegionInputChange(e)}/> 
                                <DealershipCustomDropDown 
                                    isDisabled={!selectedRegion?.id || preselectedBrandValidated}
                                    selectedOption={selectedBrand} 
                                    label="Concesionario" 
                                    items={brands} 
                                    onClickOption={(e) => handleBrandInputChange(e)}/> 
                                <DealershipCustomDropDown 
                                    isDisabled={!selectedBrand?.id}
                                    selectedOption={selectedDealership} 
                                    label="Sucursal" 
                                    items={dealershipFilter()} 
                                    onClickOption={(e) => handleDealershipInputChange(e)}/> 
                            </section>
                            <div className="disclaimer privacy">
                                <label className="custom-checkbox">
                                    <input type="checkbox" checked={checkboxValue} onChange={(e) => handleCheckboxChange(e)} />
                                    <span className="checkmark"></span>
                                </label>
                                <span className="checkbox-tex" >He leído y acepto la <a href={links.tnc_page} target="_blank">política de privacidad</a> de mis datos personales.</span>
                            </div>
                            <section className="buttons">
                                <button className="btn black enviar-solicitud-disponible" onClick={() => finishLeadRegister()} disabled={!selectedDealership?.id || !formValid}>Enviar</button>
                            </section>
                        </section>
                    </div>
                </div>
            :
                <div className="modal-box">
                    <div className="modal-body final-modal">
                        <section className="model-info">
                            <div className="title">
                                <h2>¡Muchas gracias!</h2>
                            </div>
                            <p className="instruction">
                                <strong>Gracias por tu interés en {selectedModel.name} {selectedVersion.name}. Hemos recibido tus datos y te estaremos contactando una vez que tengamos este modelo disponible.</strong>
                            </p>
                            <section className="buttons">
                                <button className="btn black" onClick={onCloseModal} disabled={!selectedDealership?.id}>¡Listo!</button>
                            </section>
                        </section>
                    </div>
                </div>
            }
        </>
    )
}

export default ModalOutOfStockModelBody